import { useMutation, useQueryClient } from 'react-query';

import { updateClient as update } from 'api/clients/updateClient';

const useUpdateClient = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: updateClient,
    isLoading,
  } = useMutation(update, {
    onSuccess: () => {
      queryClient.invalidateQueries('clients');
    },
  });

  return {
    isSuccess,
    updateClient,
    isLoading,
  };
};

export default useUpdateClient;
